import config from 'config';

const DefaultConfig = {
  cryPng: true,
  apiUrlLocal: config.API_ENDPOINT,
  apiUrlStaging: config.API_ENDPOINT,
  apiUrlProd: config.API_ENDPOINT
};
export const AppConfig = {
  ...DefaultConfig,
  ...config
};
export default AppConfig;




// WEBPACK FOOTER //
// ./src/AppConfig.js